import config from "@Config/index";
import axios from "axios";

const fetchStateUniversities = async (region_id: string) => {
  const params = {
    p: 1,
    limit: 1000,
    state: "active",
    methods: "parent_name,active_inventories_in_bound_count",
    only: "name,canonical_name,region_type,id",
    ancestor_id: region_id,
    sort_key: "name",
    sort_order: "asc",
    region_type: "establishment",
    use_java_api: true,
  };

  const { data } = await axios(`${config.API_URL}/api/v0/regions`, {
    params,
  });

  return data?.data?.result ? data.data.result : [];
};

export default fetchStateUniversities;
